import {
  Amount,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableHeaderRow,
  TableRow,
} from '@razorpay/blade/components';
import React from 'react';
import { Earning } from 'api/gql-utils/payDetails/compensationTypes';

type EarningWithId = Earning & { id: string };
const PreviewCtcTable = ({
  earning,
  columnTitles,
}: {
  earning: EarningWithId[] | undefined;
  columnTitles: string[];
}) => {
  if (earning?.length === 0) return <> </>;
  return (
    <Table
      rowDensity="compact"
      backgroundColor="transparent"
      data={{
        nodes: earning ?? [],
      }}>
      {(tableData) => {
        return (
          <>
            <TableHeader>
              <TableHeaderRow>
                {columnTitles.map((title, index) => (
                  <TableHeaderCell key={title} textAlign={index === 0 ? 'left' : 'right'}>
                    {title}
                  </TableHeaderCell>
                ))}
              </TableHeaderRow>
            </TableHeader>
            <TableBody>
              {tableData.map((item) => {
                return (
                  <TableRow key={item?.id} item={item}>
                    <TableCell>{item?.name}</TableCell>
                    <TableCell textAlign="right">
                      <Amount value={Number(item.amount ?? 0)} />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </>
        );
      }}
    </Table>
  );
};
export default PreviewCtcTable;
